import { render, staticRenderFns } from "./ContractRiskWarning.vue?vue&type=template&id=940f9d04&scoped=true"
import script from "./ContractRiskWarning.vue?vue&type=script&lang=js"
export * from "./ContractRiskWarning.vue?vue&type=script&lang=js"
import style0 from "./ContractRiskWarning.vue?vue&type=style&index=0&id=940f9d04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940f9d04",
  null
  
)

export default component.exports